'use strict';

/**
 * Module dependencies.
 */

const integration = require('@segment/analytics.js-integration');

const src = 'https://analytics.tiktok.com/i18n/pixel/events.js';
/**
 * Expose `TikTok`
 */

const TikTok = (module.exports = integration('TikTok')
    .global('TiktokAnalyticsObject')
    .global('ttq')
    .option('pixelId', '')
    .mapping('standardEvents')
    .tag(`<script src="${src}?sdkid={{ pixelId }}&lib=ttq">`)
);

/**
 * Initialize
 *
 *
 * @api public
 */

TikTok.prototype.initialize = function() {
  const ttqStr = 'ttq';
  window.TiktokAnalyticsObject = ttqStr;
  const ttq = window[ttqStr] = window[ttqStr] || [];
  ttq.methods = [
    'page',
    'track',
    'identify',
    'instances',
    'debug',
    'on',
    'off',
    'once',
    'ready',
    'alias',
    'group',
    'enableCookie',
    'disableCookie'];
  ttq.setAndDefer = function(t, e) {
    t[e] = function() {
      t.push([e].concat(Array.prototype.slice.call(arguments, 0)));
    };
  };
  for (var i = 0; i < ttq.methods.length; i++) {
    ttq.setAndDefer(ttq, ttq.methods[i]);
  }
  ttq.instance = function(t) {
    for (var e = ttq._i[t] || [], n = 0; n < ttq.methods.length; n++) {
      ttq.setAndDefer(e, ttq.methods[n]);
    }
    return e;
  };
  var pixel = this.options.pixelId;
  ttq._i = ttq._i || {};
  ttq._i[pixel] = [];
  ttq._i[pixel]._u = src;
  ttq._t = ttq._t || {};
  ttq._t[pixel] = +new Date;
  ttq._o = ttq._o || {};
  ttq._o[pixel] = {};

  this.load((err) => {
    this.ready(err);
  });
};

/**
 * Has the TikTok Pixel library been loaded yet?
 *
 * @return {Boolean}
 */
TikTok.prototype.loaded = function() {
  const isLoaded = !!(window.ttq && window.ttq.page);
  return isLoaded;
};

/**
 * Page
 *
 * @api public
 * @param {Page} page
 */

TikTok.prototype.page = function() {
  window.ttq.page();
};

TikTok.prototype.identify = function(identify) {
  const traits = identify.traits();
  if (traits.phone) {
    traits.phone_numer = traits.phone;
    delete traits.phone;
  }
  if (Object.values(traits).length === 0) {
    return;
  }
  window.ttq.identify(traits);
};

/**
 * Track
 *
 *
 * @api public
 * @param {Track} track
 */

TikTok.prototype.track = function(track) {
  const event = track.event();
  const standardEvents = this.standardEvents(event);
  const traits = window.analytics.user().traits();
  const payload = {};

  if (traits.email) {
    payload.email = traits.email;
  }

  if (standardEvents.length) {
    standardEvents.forEach((event) => {
      window.ttq.track(event, payload, {
        event_id: track.proxy('messageId'),
        email: traits.email,
      });
    });
  }

};
